import { BrowserRouter } from 'react-router-dom'
import AppRouter from '@routes/AppRouter'

const App = () => {
  return (
    <div className="h-full bg-white">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  )
}

export default App